import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModalCienciaOs from "../components/EfisModalCienciaOs";

const useTomarCiencia = (history) => {
  const [showCienciaConfirm, setShowCienciaConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });
  const [showAlertaNaoCiencia, setShowAlertaNaoCiencia] = useState(false);

  const { request, data, errors, isLoading, requestExtra } = useApiClient();

  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      toast.success("Ciência salva com sucesso.");
      history.push({
        pathname: "/app/os/executarOs/consulta",
        state: { itemKey: requestExtra },
      });
    }

    if (errors) {
      toast.error(errors.message);
    }

    setShowCienciaConfirm({ show: false });
  }, [setShowCienciaConfirm, data, errors, requestExtra, history]);

  const tomarCiencia = useCallback(
    (values, sqOrdemServico) => {
      request(apiRoutes.fiscalizacao.ordemservico.tomarCienciaOs, values, { requestExtra: sqOrdemServico });
    },
    [request],
  );

  const tomarCienciaModal = (
    <>
      <Modal size="lg" show={showAlertaNaoCiencia} onHide={() => setShowAlertaNaoCiencia(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Para prosseguir é necessário que seja registrada a sua ciência.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowAlertaNaoCiencia(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <EfisModalCienciaOs
        title="Ciência da OS"
        primaryLabel="Sim"
        secondaryLabel="Não"
        show={showCienciaConfirm.show}
        body={showCienciaConfirm.body}
        context={showCienciaConfirm.context}
        loadingConfirmationAction={isLoading}
        closeHandler={() => setShowCienciaConfirm({ show: false })}
        confirmationHandler={(sqAcaoFiscal, sqOrdemServico) => {
          tomarCiencia({ sequencialAcaoFiscal: sqAcaoFiscal, sequencialOrdemServico: sqOrdemServico }, sqOrdemServico);
        }}
      />
    </>
  );

  return {
    tomarCienciaModal,
    setShowCienciaConfirm,
    setShowAlertaNaoCiencia,
  };
};

export default useTomarCiencia;
